<ng-container *transloco="let t; read: 'customer.offer_requests'">

  <psc-section-title
    size="normal"
    [title]="offerRequest.projectName"></psc-section-title>
  <div class="flex flex-col gap-2 mb-2 text-blue1">
    <div class="flex gap-2 items-center">
      <mat-icon>email</mat-icon>
      <a href="mailto:{{offerRequest.email}}">{{offerRequest.email}}</a>
    </div>
    <div class="flex gap-2 items-center">
      <mat-icon>phone</mat-icon>
      <a href="tel:{{offerRequest.mobilePhone}}">{{offerRequest.mobilePhone}}</a>
    </div>
  </div>

  <div class="mb-4">
    <div class="">
      <div class="font-bold text-blue1 text-xl">
        {{t('investor_name')}}
      </div>
      <div class="text-xl">
        {{offerRequest.investorName | fillIfEmptyValue}}
      </div>
    </div>

    <div class="grid grid-cols-2 gap-2">
      <!-- t(eligible_for_grid_connection, optimal_power_less_than_connected_power, contact_by_company_accepted, loan_financing_for_solar_plant_desired, conceptual_project_needed, company_authorized_for_next_step_in_connection) -->
      <div *ngFor="let boolValue of boolValues">
        <div class="font-bold text-blue1">
          {{t(boolValue.translationKey)}}
        </div>
        <div>
          {{offerRequest[boolValue.prop] ? t('yes') : t('no')}}
        </div>
      </div>
    </div>
  </div>

  <form [formGroup]="formGroup"
        *ngIf="this.formGroup" class="flex flex-col gap-2">
    <psc-select
      [label]="t('offer_status')"
      [options]="statusOptions | translateLabels:t"
      formControlName="offerStatus"></psc-select>

    <psc-input
      type="number"
      [prefix]="offerRequest.currency"
      [label]="t('offer_amount')"
      formControlName="offerAmount"></psc-input>

    <psc-button [label]="t('update_offer')"
                (buttonClicked)="onSubmit()"
                [disabled]="!formGroup.valid"
                class="my-5"
                type="primary-blue-2"></psc-button>
  </form>
</ng-container>
